module.exports = __webpack_public_path__ + "img/step-tip.b5555a25.png";